import { IWorkedHoursReport } from 'src/store/reducers/workedHoursReport-reducer';
import { changeToZeroMoment } from '../timeHelpers';

export const groupWorkedHoursReportToCsv = (data: IWorkedHoursReport[]) => {
    const groupData: any = [['Month', 'Provider ID', 'Name', 'Avg Hours']];

    data.forEach((it) => {
        groupData.push([
            it.month_start ? changeToZeroMoment(it.month_start, 'MMM YYYY') : '',
            it.provider_id ?? '',
            it.full_name ?? '',
            it.avg_hours ? Number(it.avg_hours).toFixed(2) : '',
        ]);
    });

    return groupData;
};
